import {
    CHANGE_NUMBER_OF_CELLS,
    IS_VISITED_FINISH,
    PUSH_DATA_FROM_FORM,
    PUSH_VALUE,
    RESET
} from "../constants/constants";

const initialState = {
    width: 100,
    length: 200,
    wallWidth: 15,
    height: 95,
    deckel : true,
    boden : true,
    deckelklasse : "A15",
    isVisitedFinish: false
};

export const buildValues = (state = initialState, action) => {
   switch (action.type) {
       case PUSH_VALUE : {
           return {
               ...state,
               ...action.payload
           };
       }
       case CHANGE_NUMBER_OF_CELLS : {
           return{
               ...state,
               height : action.payload
           }
       }
       case IS_VISITED_FINISH : {
           return {
               ...state,
               isVisitedFinish: true
           };
       }
       case PUSH_DATA_FROM_FORM : {
           return {
               ...state,
               email: action.payload.from_email,
               dataFromForm : action.payload
           }
       }
       case RESET : {
           return {
               ...initialState,
               email: state.email,
               dataFromForm: state.dataFromForm
           }
       }
       default : {
           return state;
       }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/buildValuesGeneral.js